import { PhxConstants } from '../model';

export const rateTypeAbbreviations: Partial<Record<PhxConstants.RateType, () => string>> = {
    [PhxConstants.RateType.Primary]: () => $localize`:@@timesheet.abbreviations.regular:Regular`,
    [PhxConstants.RateType.Overtime]: () => $localize`:@@timesheet.abbreviations.overtime:Overtime`,
    [PhxConstants.RateType.DoubleTime]: () => $localize`:@@timesheet.abbreviations.doubleTime:Double time`
};

export const autoCalculateOvertimeRateTypes = new Set([PhxConstants.RateType.Overtime, PhxConstants.RateType.DoubleTime]);
